module.exports = __webpack_public_path__ + "img/sliders-up.11ac6277.svg";